import React, {
  useState,
  useRef,
  useCallback,
  useEffect,
  useContext,
  useMemo,
} from 'react';
import useOnClickOutside from '../../../hooks/useOnClickOutside';
import { Context } from '../../../context/AppContext';
import {
  SORT_BY_FILTERS,
  SORT_BY_FILTER_ICONS,
  MODALS,
} from '../../../constants';
import DropDown from './DropDown';
import NavButton from './NavButton';
import Radio from './Radio';
import ApplyButton from './ApplyButton';
import './styles.css';

const SortBy = ({ fetchMore, sort = 'r', filter }) => {
  const {
    media: { mobile },
    modal: { showModal, hideModal, modals },
  } = useContext(Context);
  const modalName = MODALS.FILTERS_SORT_BY_MOBILE;
  const [selected, setSelected] = useState(sort);
  const [applied, setApplied] = useState(sort);

  const [show, setShow] = useState();
  const [dirty, setDirty] = useState();
  const ref = useRef();
  const refMobile = useRef();
  const { show: modalShow } = modals[modalName] || {};

  useOnClickOutside(
    ref,
    useCallback(() => {
      if (show) {
        setSelected(applied);
        setShow(false);
        setDirty(false);
      }
    }, [applied, show])
  );

  useOnClickOutside(
    refMobile,
    useCallback(() => {
      if (modalShow) {
        hideModal(modalName);
      }
    }, [applied, modalShow])
  );

  const matchInitial = useMemo(() => {
    return sort === selected;
  }, [selected, sort]);

  useEffect(() => {
    setSelected(sort || 'r');
    setApplied(sort || 'r');
    setDirty(false);
  }, [sort]);

  const setSort = useCallback(value => {
    setSelected(value || 'r');
    setDirty(true);
  }, []);

  const ifIncludes = (arr, value) => (arr || '').split(',').includes(value);

  const renderFilters = () =>
    SORT_BY_FILTERS.map(({ label, value }) => (
      <Radio
        key={label}
        name="nearMe"
        value={value}
        defaultChecked={ifIncludes(selected, value)}
        onClick={() => setSort(value)}
        svg={focused =>
          SORT_BY_FILTER_ICONS(label, focused || ifIncludes(selected, value))
        }
      >
        {label}
      </Radio>
    ));

  const selectedValues = useMemo(
    () =>
      selected
        ? SORT_BY_FILTERS.reduce((agg, { label, value }) => {
            if (ifIncludes(selected, value)) {
              return agg.concat(label);
            }
            return agg;
          }, [])
        : null,
    [selected]
  );
  return (
    <div className="Listview__Filters__wrapper" ref={ref}>
      <NavButton
        active={!!sort}
        onClick={() => {
          if (mobile) {
            showModal(modalName);
          } else {
            setShow(!show);
          }
        }}
        className="Listview__Filters__button--sortBy"
      >
        Sort By
      </NavButton>

      {mobile && (
        <NavButton
          className="Listview__Filters__TradingHours--show"
          active={sort === 's'}
          data-filter={sort === 's' ? null : 'Top Rated'}
          onClick={e => {
            if (sort !== 's') {
              fetchMore(e, {
                page: 0,
                filter,
                sort: 's',
              });
              setSelected('s');
              setApplied('s');
              setShow(false);
            } else {
              fetchMore(e, {
                page: 0,
                filter,
                sort: 'r',
              });
              setSelected('r');
              setApplied('r');
              setShow(false);
            }
          }}
        >
          Top Rated
        </NavButton>
      )}

      <DropDown show={show} heading="Sort By">
        <div className="Listview__Filters__options">
          {show && renderFilters()}
        </div>
        <ApplyButton
          active={dirty && !matchInitial}
          data-filter={selectedValues}
          onClick={e => {
            if (selected) {
              fetchMore(e, {
                page: 0,
                filter,
                sort: selected,
              });
              setSelected(selected);
              setApplied(selected);
            }
            setShow(false);
          }}
        >
          Apply
        </ApplyButton>
      </DropDown>
    </div>
  );
};

export default SortBy;
